import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

export interface ComponentCanDeactivate {
  getForm: () => NgForm;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    const form = component.getForm();
    return form.pristine || form.submitted ?
      true : confirm('You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
  }
}
